import styled from "styled-components";
import { device } from '../device';

interface StripesProps {
  left: string;
  right: string;
  top: string;
}
interface StripeProps {
  stripeColor: string;
  translateX: number;
  translateY: number;
}
export const Stripes = styled.div<StripesProps>`
  left: ${(props) => props.left};
  position: absolute;
  right: ${(props) => props.right};
  top: ${(props) => props.top};
  transform: skewY(-15deg) translateY(0);
  transform-origin: 100% 0;
  .small-stripe {
    width: 400px;
    @media ${device.tablet} {
      width: 800px;
    }
  }
  .very-small-stripe {
    width: 300px;
    @media ${device.tablet} {
        width: 600px;
    }
  }
`;
export const Stripe = styled.div<StripeProps>`
  background: ${(props) => props.stripeColor};
  height: 50px;
  transform: translateX(${(props) => props.translateX}px) translateY(${(props) => props.translateY}px); 
  width: 500px;
  @media ${device.tablet} {
    height: 75px;
    width: 800px;
  }
  @media ${device.laptop} {
    height: 95px;
    width: 1000px;
  }
`;
